<template>
  <div class="awards" data-medusa data-medusa-animation="awards">
    <div
      class="awards-container"
      data-in-out
      data-in-out-animation="slide"
    >
      <div class="awards__image" ref="floating"></div>
      <div class="awards__content">
        <div class="awards__title">
          <span>Awards.</span>
        </div>
        <div v-for="(award, index) in awards" :key="index" class="award">
          <div class="award__name">
            <span>{{ award['award-name'] }}</span>
          </div>
          <div class="award__score">
            <span>{{ award['award-detail'] }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TweenMax from 'gsap/TweenMaxBase';
import engine from '../../scripts/engine';

export default {
  name: 'Awards',

  props: ['data'],

  computed: {
    awards() {
      return this.data.awards;
    },
  },

  mounted() {
    this.$nextTick(() => {
      engine.add(() => {
        const image = this.$refs.floating;
        const center = window.innerHeight / 2;
        const fromCenter = (image.getBoundingClientRect().top + image.getBoundingClientRect().height / 2) - center;
        TweenMax.set(image, { y: fromCenter * 0.4, rotation: fromCenter * 0.005 });
      }, 'awards-scroll');
    });
  },

  beforeDestroy() {
    engine.remove('awards-scroll');
  },
};
</script>

<style lang="scss" scoped>
.awards {
  position: relative;
  margin-top: calc((100vh / 18) * 5);

  @include mq($until: ipadL) {
    margin-top: calc((100vh / 18) * 2);
    margin-left: 0px;
  }

  &__image {
    position: absolute;
    width: calc(721px * var(--rw));
    height: calc(1080px * var(--rw));
    left: calc(-200px * var(--rw));
    top: calc(-200px * var(--rw));
    background-image: url('/static/img/03.png');
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
  }

  &__content {
    position: relative;
    margin-left: calc((100vw / 64) * 23);
    z-index: 2;
  }

  &__title {
    font-size: rem(150px);
    font-size: calc(150px * var(--rw));
    color: $color-white;
    margin-bottom: calc((100vh / 18) * 1);

    @include mq($until: ipadL) {
      font-size: rem(60px);
      font-size: calc(60px * var(--rw));
    }
  }

  .award {
    margin-bottom: calc((100vh / 18) * 1);
    color: $color-white;

    &__name {
      font-family: 'IGT Frankling Gothic';
      font-size: rem(22px);
      font-size: $font-size-text;
      color: $color-primary;
      font-weight: bold;
      text-transform: uppercase;
      margin-bottom: 5px;
    }

    &__score {
      color: rgba($color: $color-white, $alpha: 0.8);
      font-size: rem(22px);
      font-size: $font-size-text;
    }
  }
}
</style>
